module.exports = __webpack_public_path__ + "img/202509_02.35be7b74.jpg";